import { render } from "./InputSelectDisabled.vue?vue&type=template&id=11f7eb11&lang=true"
import script from "./InputSelectDisabled.vue?vue&type=script&lang=js"
export * from "./InputSelectDisabled.vue?vue&type=script&lang=js"
script.render = render

export default script